import React, { useState } from "react"
import { Button, Row, Col } from "reactstrap"
import { Modal } from "react-bootstrap"
import { Link } from "gatsby"

import SocilaList from "../ContactUs/socialList"
import ContactUs from "../ContactUs/contactUs"

const Footer = props => {
  const [show, setShow] = useState(false)

  const handleClose = () => setShow(false)
  const handleShow = () => setShow(true)

  const closeContactus = () => setShow(false)
  return (
    <div className="footer">
      <div className="footer-links-wrapper">
        <div className="link-group">
          <div className="title medium-font">Meetrix Products</div>
          <div className="small-font">
            <a href="https://teach.meetrix.io" target="_blank" rel="noopener">
              Meetrix Teach
            </a>
          </div>
          <div className="small-font">
            <a href="https://meet.meetrix.io" target="_blank" rel="noopener">
              Meetrix Meet
            </a>
          </div>
          <div className="small-font">
            <a href="https://screenapp.io" target="_blank" rel="noopener">
              Screenapp
            </a>
          </div>
          <div className="small-font">
            <a
              href="https://remotrix.meetrix.io/"
              target="_blank"
              rel="noopener"
            >
              Remotrix
            </a>
          </div>
        </div>
        <div className="link-group">
          <div className="title medium-font">Solutions</div>
          <div className="small-font">
            <Link to="/solutions/online-tutoring">Online Tutoring</Link>
          </div>
          <div className="small-font">
            <Link to="solutions/telemedicine">Telemedicine</Link>
          </div>
          <div className="small-font">
            <Link to="solutions/chat-applications">Chat Applications</Link>
          </div>
          <div className="small-font">
            <Link to="solutions/serverless-solutions">
              Serverless Solutions
            </Link>
          </div>
        </div>
        <div className="link-group">
          <div className="title medium-font">Services</div>
          <div className="small-font">
            <Link to="services/commercial-support-for-jitsi">
              Commercial Support for Jitsi Meet
            </Link>
          </div>
          {/* <div className="small-font"><Link to="#">Consultation for WebRTC Projects</Link></div> */}
          <div className="small-font">
            <Link to="services/custom-communication-system">
              Custom Communication Systems
            </Link>
          </div>
        </div>
        <div className="link-group">
          <div className="title medium-font">Learn More</div>
          <div className="small-font">
            <Link to="/aboutus">About Us</Link>
          </div>
          <div className="small-font">
            <Link to="/partners">Partner with us</Link>
          </div>
          <div className="small-font">
            <Link to="/privacy-policy">Privacy policy</Link>
          </div>
          {/* <div className="small-font"><a href="#">Webinars</a></div> */}
        </div>
        {/*<div className="button-wrapper"><Button className="small-font" color="contact-us" onClick={handleShow} >CONTACT US</Button></div>*/}
      </div>
      <Row>
        <Col md="6" sm="12" xs={{ order: 2 }} sm={{ order: 1 }}>
          &copy; 2017-2020, Meetrix Technology Solutions
        </Col>
        <Col md="6" sm="12" sm={{ order: 1 }} className="social-container">
          <SocilaList />
        </Col>
      </Row>

      <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton />
        <ContactUs closeContactus={closeContactus} />
      </Modal>
    </div>
  )
}

export default Footer
